import React from "react";
import { FileEarmarkText, Link45deg } from "react-bootstrap-icons";
import { IVODAttachments } from "../../types";
import "./vod-attachments.css";

interface VODAttachmentsMenuProps {
  attachments: IVODAttachments;
}

export const VODAttachmentsMenu: React.FC<VODAttachmentsMenuProps> = ({ attachments }) => {
  const hasContent = attachments.files.length > 0 || attachments.hyperlinks.length > 0;

  if (!hasContent) {
    return <p style={{ color: "#aaa", fontSize: "14px" }}>No attachments for this video.</p>;
  }

  return (
    <div className="vod-attachments-menu">
      {attachments.files.length > 0 && (
        <div className="vod-attachments-section">
          <h4 className="vod-attachments-section-title">Files</h4>
          {attachments.files.map((file) => (
            <a
              key={file.fileId}
              href={file.downloadUrl}
              download={file.originalFilename}
              target="_blank"
              rel="noopener noreferrer"
              className="vod-attachment-item"
            >
              <FileEarmarkText className="vod-attachment-icon" />
              <span className="vod-attachment-label">
                {file.title || file.originalFilename}
              </span>
            </a>
          ))}
        </div>
      )}

      {attachments.hyperlinks.length > 0 && (
        <div className="vod-attachments-section">
          <h4 className="vod-attachments-section-title">Links</h4>
          {attachments.hyperlinks.map((link) => (
            <a
              key={link.hyperLinkId}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="vod-attachment-item"
            >
              <Link45deg className="vod-attachment-icon" />
              <span className="vod-attachment-label">{link.title}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
